import axios from 'axios'
import NProgress from 'nprogress'
import store from '../store/store'
import { baseUrls } from './../const'

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  async config => {
    const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'))
    if (tokenInfo && tokenInfo.access_token) {
      config.headers.Authorization = `Bearer ${tokenInfo.access_token}`
    }

    // Proactively refresh if token expires within 2 minutes
    if (
      tokenInfo &&
      tokenInfo.expires_at &&
      !store.state.user.token_refreshing
    ) {
      const minutesLeft = (tokenInfo.expires_at - Date.now()) / 60000
      if (minutesLeft < 2) {
        try {
          await store.dispatch('user/refreshAzureToken')
          const fresh = JSON.parse(localStorage.getItem('tokenInfo'))
          config.headers.Authorization = `Bearer ${fresh.access_token}`
        } catch {
          store.dispatch('user/logout')
          return Promise.reject(
            new Error('Session expired. Please sign in again.')
          )
        }
      }
    }

    let url = config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      store.commit('user/SET_LOADING', 1)
      NProgress.start()
    }
    return config
  },
  error => error
)

apiClient.interceptors.response.use(
  response => {
    var url = response.config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      store.commit('user/SET_LOADING', -1)
      NProgress.done()
    }
    return response
  },
  error => {
    store.commit('user/STOP_LOADING')
    NProgress.done()

    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout')
    }

    return Promise.reject(error)
  }
)

export default apiClient
